import { render, staticRenderFns } from "./CycleIframeSitecore.vue?vue&type=template&id=47c712ff"
import script from "./CycleIframeSitecore.vue?vue&type=script&lang=js"
export * from "./CycleIframeSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports